<template>
  <modal name="modal-signup" :width="620" :key="layoutName">
    <component :is="activeElem" />
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from 'theme/components/core/Modal'
import Login from 'theme/components/core/blocks/Auth/Login'
import Register from 'theme/components/core/blocks/Auth/Register'
import ForgotPass from 'theme/components/core/blocks/Auth/ForgotPass'

export default {
  name: 'SignUp',
  computed: {
    ...mapState({
      activeElem: state => state.ui.authElem
    }),
    layoutName () {
      return this.$route.meta.layout || 'default'
    }
  },
  components: {
    Modal,
    Login,
    Register,
    ForgotPass
  }
}
</script>

<style scoped>
  .modal {
    font-size: 18px;
  }
</style>
